<template>
    <div>
        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                    <font-awesome-icon class="md-icon" :icon="['fas', 'comment']"/>
                </div>
            </md-card-header>
            <md-card-content>
                <div class="flex justify-between items-center">
                    <div>
                        <span class="mr-3">{{ $moment(intervention.planification_date).year() }}</span>
                        <span class="mr-3">{{ intervention.site.client.name }}</span>
                        <span class="mr-3">{{ intervention.site.name }}</span>
                        <span v-if="intervention.contract">{{ intervention.contract.name }}</span>
                    </div>
                    <div>
                        <md-button class="md-icon-button md-raised my-0" v-if="intervention.contract" @click="$emit('toggle-interventions-list')">
                            <span class="leading-none font-medium">Voir la liste</span>
                        </md-button>
                    </div>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
export default {
    name: "Header",
    props: {
        intervention: {
            type: Object
        }
    }
}
</script>

<style scoped>

</style>
